import Awards from './Awards';
import Footer from './Footer';
import MainBanner from './MainBanner';
import Stats from './Stats';

export { Awards, Footer, MainBanner, Stats };
